// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__rHJIB","logoBlock":"Advt_logoBlock__DCa3M","title":"Advt_title__4XSwJ","qrsWrapper":"Advt_qrsWrapper__z4PN-","qrCode":"Advt_qrCode__1+z0-"};